module.exports = __webpack_public_path__ + "img/Z82_16.ed255a2a.jpg";